import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
} from '@tanstack/react-query';
import service from '../service';
import type {
  CreateRegistrationCodePayload,
  RegistrationCode,
} from '../types/registrationCode';
import { inviteCodeQueryKeys, retryInviteCodeMutation } from './useInviteCodes';

export function useCreateInviteCode(
  options?: UseMutationOptions<
    RegistrationCode,
    Error,
    CreateRegistrationCodePayload
  >,
) {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};

  return useMutation({
    mutationKey: ['inviteCode', 'create'],
    mutationFn: async (payload: CreateRegistrationCodePayload) =>
      service.createRegistrationCode(payload),
    retry: retryInviteCodeMutation,
    ...restOptions,
    onSuccess: (data, variables, context, mutation) => {
      queryClient.invalidateQueries({ queryKey: inviteCodeQueryKeys.all });
      onSuccess?.(data, variables, context, mutation);
    },
  });
}
